class ScrollEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    function scrollFunction() {
      const this_y = window.pageYOffset;
      if (this_y > 300) {
        document.querySelector(".side-btn").classList.add("js-active");
      } else {
        document.querySelector(".side-btn").classList.remove("js-active");
      }
    }
    
    /* スクロールした時にfunctionを実行する */
    window.onscroll = function () {
      scrollFunction();
    }
  }
}